import React from "react";
import styled from "styled-components";
import EventCardList from "../components/Events/EventCardList";

const Container = styled.main`
  max-width: 64rem;
  width: 100%;
  margin: auto;
  margin-top: 3rem;
  @media screen and (max-width: 64em) {
    padding: 0 2rem;
  }
  @media screen and (max-width: 20em) {
    padding: 0 1rem;
  }
`;

const Events = props => (
  <Container>
    <EventCardList events={props.data.events.edges} />
  </Container>
);

export default Events;

export const EventsQuery = graphql`
  query getAllEvents {
    events: allEvent(sort: { fields: [date], order: ASC }) {
      edges {
        node {
          id
          title
          description
          date
          locationName
          link
          image {
            handle
            width
            height
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/events.js